import styles from './visit-profile.module.scss';
import { useParams } from 'react-router-dom';
import ViewProfile from 'components/prefabs/view-profile-popover/view-profile-popover';

function VisitProfilePage() {
  const { userId } = useParams();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <ViewProfile showEditButton={false} user_id={userId!} onClose={() => {}} type="page" />
      </div>
    </div>
  );
}

export default VisitProfilePage;
